import { render, staticRenderFns } from "./header.vue?vue&type=template&id=33a0c04c&scoped=true&"
var script = {}
import style0 from "./header.vue?vue&type=style&index=0&id=33a0c04c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a0c04c",
  null
  
)

export default component.exports